export const CURRENCY_LIST = [
  {
    name: "USD",
    symbol: "usd",
    symbol2: "usdt",
  },
  {
    name: "EUR",
    symbol: "eur",
    symbol2: "eur",
  },
  {
    name: "GBP",
    symbol: "gbp",
    symbol2: "gbp",
  },
];
